module.exports = require("acorn");;